<ng-container *transloco="let t">
  <div class="flex flex-col gap-4">
    <app-bulk-upload-report-content
      [fields]="fields"
      [updates]="reportUpdates"
      [creations]="reportCreations"
      [errors]="errors"
      entityIdField="productGroupId"
    />

    <div class="flex justify-end pt-2">
      @if (!uploadButtonDisabled) {
        <button iButton size="sm" [loading]="uploadLoading()" (click)="uploadData()">{{ t("common.upload") }}</button>
      }
    </div>
  </div>
</ng-container>
